import { render } from "./TimeslotSelect.vue?vue&type=template&id=5caef0d6&ts=true"
import script from "./TimeslotSelect?vue&type=script&lang=ts"
export * from "./TimeslotSelect?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__